import { generateGuid } from "./";

// Utility object to manage cart session
export const cartSession = {
  // Save session
  save: (key, value) => {
    if (!key || !["cartId", "sessionId"].includes(key)) return;

    const existingData = cartSession.get(null); // Get existing session
    const sessionData = { ...existingData, [key]: value }; // Update only the provided key
    localStorage.setItem("cartSession", JSON.stringify(sessionData));
  },

  // Get session
  get: (type = "sessionId") => {
    const data = localStorage.getItem("cartSession");
    const session = data
      ? JSON.parse(data)
      : { cartId: "", sessionId: generateGuid() };

    if (type === "cartId") return session.cartId;
    if (type === "sessionId") return session.sessionId;
    return session; // Default: return full session object
  },

  // Clear session
  clear: () => localStorage.removeItem("cartSession"),

  // Clear session only if cart is empty
  isExist: () => localStorage.getItem("cartSession"),
};
